import { Pipe, PipeTransform } from '@angular/core';

/**
 * Allows iterating over object properties within a template
 * @example
 * ```html
 * <span *ngFor="let item of queryParamsAsObjectSig() | keyValuePairs; let last = last">
 *   {{ item.key }}=<b>{{ item.value }}</b><span *ngIf="!last">, &nbsp;</span>
 * </span>
 * ```
 */
@Pipe({ name: 'keyValuePairs' })
export class KeyValuePairsPipe implements PipeTransform {
  transform(obj: Record<string, unknown> | null | undefined) {
    if (!obj) return [];
    return Object.entries(obj).map(([key, value]) => ({ key, value }));
  }
}
